"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.languages = void 0;
exports.languages = [
    {
        name: 'Bulgarian',
        countryName: 'Bulgaria',
        code: 'BG',
    },
    {
        name: 'Croatian',
        countryName: 'Bulgaria',
        code: 'HR',
    },
    {
        name: 'Czech',
        countryName: 'Czech Republic',
        code: 'CS',
    },
    {
        name: 'Danish',
        countryName: 'Denmark',
        code: 'DA',
    },
    {
        name: 'Dutch',
        countryName: 'The Netherlands',
        code: 'NL',
    },
    {
        name: 'English',
        countryName: 'England',
        code: 'EN',
    },
    {
        name: 'Estonian',
        countryName: 'Estonia',
        code: 'ET',
    },
    {
        name: 'Finnish',
        countryName: 'Finland',
        code: 'FI',
    },
    {
        name: 'French',
        countryName: 'France',
        code: 'FR',
    },
    {
        name: 'German',
        countryName: 'Germany',
        code: 'DE',
    },
    {
        name: 'Greek',
        countryName: 'Greece',
        code: 'EL',
    },
    {
        name: 'Hungarian',
        countryName: 'Hungary',
        code: 'HU',
    },
    {
        name: 'Irish',
        countryName: 'Ireland',
        code: 'GA',
    },
    {
        name: 'Italian',
        countryName: 'Italy',
        code: 'IT',
    },
    {
        name: 'Latvian',
        countryName: 'Republic of Latvia',
        code: 'LV',
    },
    {
        name: 'Lithuanian',
        countryName: 'Republic of Lithuania',
        code: 'LT',
    },
    {
        name: 'Maltese',
        countryName: 'Republic of Malta',
        code: 'MT',
    },
    {
        name: 'Polish',
        countryName: 'Poland',
        code: 'PL',
    },
    {
        name: 'Portuguese',
        countryName: 'Portugal',
        code: 'PT',
    },
    {
        name: 'Romanian',
        countryName: 'Romania',
        code: 'RO',
    },
    {
        name: 'Slovak',
        countryName: 'Slovakia',
        code: 'SK',
    },
    {
        name: 'Slovene',
        countryName: 'Slovenia',
        code: 'SL',
    },
    {
        name: 'Spanish',
        countryName: 'Spain',
        code: 'ES',
    },
    {
        name: 'Swedish',
        countryName: 'Sweden',
        code: 'SV',
    },
];
//# sourceMappingURL=data:application/json;base64,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